import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
export default function About(props) {
  return (
    <>
    <div className = "container text-start">
    <br/>
    <h1>About Me:</h1>
    <h4 height="10"><SyntaxHighlighter>
    Enthusiastic Programmer who 💖 to code
    </SyntaxHighlighter></h4><br/>

    <h4>Some more about me &rarr;</h4>
    <br/>
    {/**/}

    <table className="table table-striped table-dark table-sm table-hover text-center">
    <tbody>
      <tr>
        <th scope="row">Name</th>
        <td>Eklavya Chandra</td>
      </tr>
      <tr>
        <th scope="row">Age</th>
        <td>15 yo</td>
      </tr>
      <tr>
        <th scope="row">Profession</th>
        <td>Student</td>
      </tr>
      <tr>
        <th scope="row">Nationality</th>
        <td>Indian</td>
      </tr>
      <tr>
        <th scope="row">Hobby</th>
        <td>Programming and Gaming</td>
      </tr>
      <tr>
        <th scope="row">Skilled in Stack</th>
        <td>PERN</td>
      </tr>
    </tbody>
  </table>

    {/**/}
    <br/>
    <h4>You can get in touch with me either from contact section or <a target="_blank" href = "https://t.me/eklavyachandra">here</a>
    </h4>
    </div>
    </>
  )
}
